import type { AnySchema } from 'joi';

import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { UserResponseSchema } from '../../generic/user-response/user-response-schema';

import { UserResponseUpdateUserError } from './user-response-update-user-error';

export class UserResponseUpdateUserSchema extends UserResponseSchema {
  protected static readonly userId = 'userId';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////
  public static readonly Defaults = class extends UserResponseSchema.Defaults {
    public static readonly userId = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[UserResponseUpdateUserSchema.error] = SchemaField.string(UserResponseUpdateUserSchema.Defaults.error)
      .optional()
      .valid(...Object.values(UserResponseUpdateUserError));
    parameters[UserResponseUpdateUserSchema.userId] = SchemaField.string(UserResponseUpdateUserSchema.Defaults.userId);

    return parameters;
  }
}
